import { getDefaultPinCode } from '../modules/location/location.actions';
import { selectDefaultPinCodes } from '../modules/location/location.selectors';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

export const useDefaultPincodes = () => {
  const defaultPinCodes = useSelector(selectDefaultPinCodes);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchDefaultPinCodes = async () => {
      try {
        if (defaultPinCodes?.defaultTtlockPinCodes?.length === 0) {
          await dispatch(getDefaultPinCode());
        }
      } catch (e) {
        console.log('Error while retrieving the default pincodes', e);
      }
    };
    fetchDefaultPinCodes();
  }, []);

  return defaultPinCodes;
};
